import { render, staticRenderFns } from "./sky-uploadimg.vue?vue&type=template&id=00cf84b2&scoped=true"
import script from "./sky-uploadimg.vue?vue&type=script&lang=js"
export * from "./sky-uploadimg.vue?vue&type=script&lang=js"
import style0 from "./sky-uploadimg.vue?vue&type=style&index=0&id=00cf84b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf84b2",
  null
  
)

export default component.exports